import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowUpRight, MapPin } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative w-full h-screen min-h-[720px] overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat scale-105"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1920&q=80')",
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/55" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center pt-24">
        <div className="animate-fadeInUp max-w-5xl">
          {/* Eyebrow pill */}
          <div className="inline-flex items-center gap-2 border-2 border-white/70 backdrop-blur-sm rounded-full px-5 py-2 mb-10">
            <span className="text-white text-xs md:text-sm font-light tracking-[0.18em] uppercase">
              Free home delivery within 10km
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-white text-5xl md:text-7xl lg:text-[88px] font-medium mb-7 font-display-serif tracking-tight leading-[1.05]">
            Satis Furniture
          </h1>

          {/* Subheading */}
          <p className="text-white/90 text-lg md:text-2xl font-light mb-12 max-w-2xl mx-auto tracking-wide">
            Furniture Shop in Campsie, Sydney — Factory Outlet Prices, every day.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
            <Link
              to="/furniture"
              className="inline-flex items-center gap-2 bg-white text-black px-8 py-3.5 rounded-full text-sm font-medium hover:bg-gray-100 btn-transition"
            >
              Browse Collection
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </Link>
            <a
              href="tel:+61411418088"
              className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-3.5 rounded-full text-sm font-medium hover:bg-white hover:text-black btn-transition"
            >
              <Phone className="w-4 h-4" strokeWidth={1.8} />
              0411 418 088
            </a>
          </div>

          {/* Address pill */}
          <a
            href="https://maps.google.com/?q=12+Perry+St+Campsie+NSW+2194"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors text-sm group"
          >
            <MapPin className="w-4 h-4" strokeWidth={1.5} />
            <span className="border-b border-white/40 group-hover:border-white pb-0.5">
              12 Perry St, Campsie NSW 2194, Australia
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
